export default __webpack_public_path__ + "static/media/logo.e751b67b.svg";